import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { uiActions } from "../../store";
import PopUpModal from "../PopUpModal/PopUpModal";
import styles from "./PatternSizeSelectorModal.module.css";
import { visualizerActions } from '../../store';
import arrow from './assets/arrow.svg';


export default function PatternSizeSelectorModal({handlePatternSizeSelect}) {
    
    const dispatch = useDispatch();
    const matchingPatterns = useSelector(state => state.visualizer.matchingPatterns);

    const handleClose = function () {
        dispatch(uiActions.setPatternSizeSelectorModalActive(false));
    }

    const handlePatternSelect = (pattern) => {
        dispatch(visualizerActions.setActivePattern(pattern));
        handlePatternSizeSelect(pattern);
    }

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.mainContent}>
                <h1>Select your pattern</h1>
                <div className={styles.patternDiv}>
                    {matchingPatterns.map((pattern, index) => {
                        const patternName = pattern.name || pattern.patternName || '';
                        const colorName = pattern.color || '';
                        const displayName = colorName ? `${patternName} ${colorName}` : patternName;
                        const patternId = pattern.id || pattern.patternId || '';
                        const thumbnail = `patterns/${patternName} ${colorName}.jpg`;
                        
                        return (
                            <div key={index} className={styles.sizeDiv} onClick={() => handlePatternSelect(pattern)}>
                                <img src={thumbnail} alt={displayName} />
                                <div className={styles.subDiv}>
                                    <h4>{displayName}</h4>
                                    <img src={arrow} alt='arrow' />
                                </div>
                            </div>
                        );
                    })}
                </div>
                </div>
            </PopUpModal>
        </>
    );
}
